import { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  ArrowRightOutlined,
  DeleteOutlined,
  EyeOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import appConfig from "../../../config/appConfig";

import dayjs from "dayjs";
import "../../../assets/styles/DatePicker.css";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";

const { Text } = Typography;
const { TextArea } = Input;

const InfoRow = ({ label, value, last }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      borderBottom: last ? 0 : "1px solid #F3F4F6",
      minHeight: 40,
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9FAFB")}
    onMouseLeave={(e) =>
      (e.currentTarget.style.backgroundColor = "transparent")
    }
  >
    <div
      style={{
        flex: "0 0 45%",
        padding: "8px 12px",
        backgroundColor: "#F8FAFC",
        borderRight: "1px solid #E5E7EB",
        fontWeight: 600,
        fontSize: 12,
        color: "#374151",
        minHeight: 40,
        display: "flex",
        alignItems: "center",
      }}
    >
      {label}
    </div>
    <div
      style={{
        flex: "0 0 28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ArrowRightOutlined style={{ fontSize: 11, color: "#9ca3af" }} />
    </div>
    <div
      style={{
        flex: 1,
        padding: "8px 10px 8px 0",
        fontSize: 12,
        color: "#111827",
        display: "flex",
        alignItems: "center",
      }}
    >
      {value ?? "—"}
    </div>
  </div>
);

const NewCashWithdrawal = (props) => {
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [savingsAccountDetails, setSavingsAccountDetails] = useState(null);
  const [clientSignature, setClientSignature] = useState(null);
  const [isPhotoPreviewVisible, setIsPhotoPreviewVisible] = useState(false);
  const [isProfilePreviewVisible, setIsProfilePreviewVisible] = useState(false);
  const [denomOptions, setDenomOptions] = useState([]);
  const [profileImageData, setProfileImageData] = useState(null);

  const [denomInput, setDenomInput] = useState({
    denomCode: null,
    denomCount: 0,
    denomValue: 0,
  });
  const [denomEntries, setDenomEntries] = useState([]);
  const [accountSearchValue, setAccountSearchValue] = useState("");
  const [tillBatchId, setTillBatchId] = useState([]);

  function getAccountDetails(accountNo) {
    if (!accountNo) return;
    setIsLoading(true);
    const url = `${apiConfig.GetByAccountNo}/${accountNo}?associations=all`;

    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
        setIsLoading(false);
      } else {
        setSavingsAccountDetails(res);
        form.setFieldsValue({
          currencyCode: res?.currency?.code || "",
        });
        getClientDetails(res.clientId, res.officeId);
        getTransactionTemplate();
        getClientDetails(res.clientId, res.officeId);
      }
    });
  }

  const getTransactionTemplate = () => {
    let body = {
      session: userData.session,
    };

    const url = `${apiConfig.Transaction}/template?officeId=${userData?.officeId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempDenominationOptions = [];

        objList?.denomCodes?.forEach((element) => {
          tempDenominationOptions.push({
            label: element,
            value: element,
          });
        });

        form.setFieldsValue({
          transactionDate: objList?.tellerBatchMasts[0]?.businesDate
            ? dayjs(objList?.tellerBatchMasts[0]?.businesDate)
            : null,
        });

        setDenomOptions(tempDenominationOptions);
        setTillBatchId(objList?.tellerBatchMasts[0]?.batchId);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  async function fetchClientSignature(cId) {
    try {
      const docs = await new Promise((resolve, reject) => {
        BOM.FetchReqAction(
          { session },
          `${apiConfig.Clients}/${cId}/documents`,
          (err, res) => (err ? reject(err) : resolve(res || [])),
        );
      });
      const unique = BOM.GetUnique(docs, "name");
      const sig = unique.find(
        (d) => d.name?.toLowerCase() === "clientsignature",
      );
      if (!sig) return;

      const url = `${apiConfig.Clients}/${cId}/documents/${sig.id}/attachment?tenantIdentifier=default`;
      const { headers } = appConfig.apiSettings;
      headers.Authorization = session;
      const tfaToken = Cookies.get("tfaToken");
      if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
        headers["Fineract-Platform-TFA-Token"] = tfaToken;
      } else {
        delete headers["Fineract-Platform-TFA-Token"];
      }
      const response = await axios({
        method: "GET",
        url,
        headers,
        responseType: "blob",
      });
      setClientSignature(URL.createObjectURL(new Blob([response.data])));
    } catch (e) {
      console.error("Error fetching client signature:", e);
    }
  }

  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };

  const getProfileImage = (cId) => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${cId}/images`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
      } else {
        try {
          if (res && res.length > 0) {
            if (typeof res === "string" && res.startsWith("data:image")) {
              setProfileImageData(res);
            } else if (
              Array.isArray(res) &&
              res[0] &&
              res[0].contentType &&
              res[0].contentType.includes("image")
            ) {
              const imageId = res[0].id;
              setProfileImageData({
                id: imageId,
                url: `${apiConfig.Clients}/${cId}/images/${imageId}?tenantIdentifier=default`,
              });
            } else if (
              res[0] &&
              typeof res[0] === "string" &&
              res[0].startsWith("data:image")
            ) {
              setProfileImageData(res[0]);
            } else if (res && typeof res === "string") {
              if (isBase64(res)) {
                setProfileImageData(`data:image/jpeg;base64,${res}`);
              }
            }
          }
        } catch (error) {
          console.error("Error processing profile image:", error);
        }

        setIsLoading(false);
      }
    });
  };

  function getClientDetails(cId, officeId) {
    if (!cId) return;

    fetchClientSignature(cId);
    getProfileImage(cId);
  }

  const onSearchAccount = () => {
    getAccountDetails(accountSearchValue);
  };

  const onCancel = () => navigate("/tlo0900", { replace: false });

  const getVaultCurrencyInfos = () =>
    denomEntries.map((entry) => ({
      vaultCurrencyInfo: {
        locale: "en",
        currencyCode: savingsAccountDetails?.currency?.code,
        denomCode: entry.denomCode,
        denomCount: String(entry.denomCount),
        denomValue: entry.denomValue,
        denomName: savingsAccountDetails?.currency?.code,
      },
    }));

  const onSubmit = (values) => {
    if (!savingsAccountDetails?.id) {
      BOM.AlertMsg(cnt.DANGER, "Please look up a valid account first.");
      return;
    }

    if (denomEntries.length === 0) {
      BOM.AlertMsg(cnt.WARNING, "Please add at least one denomination entry.");
      return;
    }

    const totalDenomValue = denomEntries.reduce(
      (sum, e) => sum + Number(e.denomValue || 0),
      0,
    );
    if (totalDenomValue !== Number(values.amount)) {
      BOM.AlertMsg(
        cnt.WARNING,
        `Total denomination value (${totalDenomValue.toLocaleString()}) must equal the transaction amount (${Number(values.amount).toLocaleString()}).`,
      );
      return;
    }

    const payload = {
      ...values,
      accountNo: savingsAccountDetails?.id,
      action: "REC",
      txnType: "WTH",
      transactionDate: BOM.DateTime(values.transactionDate, "only-date"),
      isClientTrx: true,
      office: userData.officeId,
      status: 2,
      tillBatchId: tillBatchId,
      vaultCurrencyInfos: getVaultCurrencyInfos(),
      method: "POST",
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    delete values.accountNo;

    const url = `${apiConfig.Transaction}?officeId=${userData?.officeId}`;

    setIsLoading(true);
    BOM.FetchReqAction(payload, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Sent cash successfully");
        setIsLoading(false);
        navigate("/tlo0400");
      }
    });
  };

  const handleDenomInputChange = (field, value) => {
    setDenomInput((prev) => {
      if (field === "denomCode") {
        return {
          ...prev,
          denomCode: value,
          denomValue: Number(value || 0) * Number(prev.denomCount || 0),
        };
      }
      if (field === "denomCount") {
        const countValue = Number(value || 0);
        return {
          ...prev,
          denomCount: value,
          denomValue: Number(Number(prev.denomCode) || 0) * countValue,
        };
      }
      return { ...prev, [field]: value };
    });
  };

  const handleAddDenom = () => {
    const { denomCode, denomCount } = denomInput;
    if (!denomCode) return;
    const denomAmount =
      Number(String(denomCode ?? "").replace(/,/g, "")) *
      Number(denomCount ?? 0);

    if (!Number.isFinite(denomAmount) || denomAmount < 0) {
      BOM.AlertMsg(cnt.WARNING, "Please select a valid denomination and count");
      return;
    }

    const option = denomOptions.find((o) => o.value === denomCode);
    setDenomEntries((prev) => [
      ...prev,
      {
        id: Date.now(),
        denomCode,
        denomLabel: option?.label ?? String(denomCode),
        denomCount: denomCount ?? 0,
        denomValue: denomAmount,
      },
    ]);
    setDenomInput({ denomCode: null, denomCount: null, denomValue: 0 });
  };

  const removeDenomEntry = (id) => {
    setDenomEntries((prev) => prev.filter((e) => e.id !== id));
  };

  const accountSummaryRows = savingsAccountDetails
    ? [
        { label: "Account Name", value: savingsAccountDetails.clientName },
        {
          label: "Currency",
          value: savingsAccountDetails?.currency?.displayLabel,
        },
        {
          label: "Current Balance",
          value: Number(
            savingsAccountDetails?.summary?.accountBalance ??
              savingsAccountDetails?.accountBalance,
          ).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        },
        {
          label: "Available Balance",
          value: Number(
            savingsAccountDetails?.summary?.availableBalance ??
              savingsAccountDetails?.availableBalance,
          ).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        },
      ]
    : [];

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.cashWithdrawal}
        pageItems={staticConfig.cashWithdrawalItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 10,
              }}
            >
              Account Lookup
            </div>

            <Row style={{ marginBottom: 24 }}>
              <Col span={12}>
                <Form.Item
                  label={labelConfig.accountNo}
                  name="accountNo"
                  style={{ marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.accountNo),
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.accountNo,
                      )}
                      style={{ height: 44 }}
                      value={accountSearchValue}
                      onChange={(e) => setAccountSearchValue(e.target.value)}
                      onPressEnter={onSearchAccount}
                      allowClear
                    />
                    <Button
                      className="of-primaryBtnColor"
                      onClick={onSearchAccount}
                      style={{ height: 44 }}
                    >
                      <SearchOutlined />
                    </Button>
                  </Space.Compact>
                </Form.Item>
              </Col>
            </Row>

            {/* ── Account Summary + Client Signature ─ */}
            {savingsAccountDetails && (
              <Row gutter={24} style={{ marginBottom: 24 }}>
                {/* Account Summary */}
                <Col span={14}>
                  <div
                    style={{
                      border: "1px solid #E5E7EB",
                      borderRadius: 10,
                      overflow: "hidden",
                      height: 210,
                    }}
                  >
                    <div
                      style={{
                        padding: "8px 12px",
                        background:
                          "linear-gradient(135deg, rgba(21,204,174,0.1) 0%, rgba(79,236,160,0.1) 100%)",
                        borderBottom: "1px solid #E5E7EB",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#0d9488",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                      }}
                    >
                      Account Summary
                    </div>
                    {accountSummaryRows.map((row, i) => (
                      <InfoRow
                        key={row.label}
                        label={row.label}
                        value={row.value}
                        last={i === accountSummaryRows.length - 1}
                      />
                    ))}
                  </div>
                </Col>

                {/* Client Signature */}
                <Col span={10}>
                  <div
                    style={{
                      border: "1px solid rgba(21,204,174,0.25)",
                      borderRadius: 10,
                      overflow: "hidden",
                      height: 210,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        padding: "8px 12px",
                        background:
                          "linear-gradient(135deg, rgba(21,204,174,0.1) 0%, rgba(79,236,160,0.1) 100%)",
                        borderBottom: "1px solid rgba(21,204,174,0.2)",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#0d9488",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexShrink: 0,
                      }}
                    >
                      <span>Client Signature</span>
                      {clientSignature && (
                        <Button
                          size="small"
                          icon={<EyeOutlined />}
                          type="text"
                          style={{ color: "#15CCAE", fontSize: 11 }}
                          onClick={() => setIsPhotoPreviewVisible(true)}
                        >
                          View Signature
                        </Button>
                      )}
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "12px 16px",
                        background: "#fafafa",
                        overflow: "hidden",
                      }}
                    >
                      <Image
                        style={{ display: "none" }}
                        src={clientSignature || ""}
                        preview={{
                          visible: isPhotoPreviewVisible,
                          onVisibleChange: (v) => setIsPhotoPreviewVisible(v),
                          src: clientSignature,
                        }}
                      />
                      <Image
                        style={{ display: "none" }}
                        src={profileImageData?.url || profileImageData || ""}
                        preview={{
                          visible: isProfilePreviewVisible,
                          onVisibleChange: (v) => setIsProfilePreviewVisible(v),
                          src: profileImageData?.url || profileImageData,
                        }}
                      />
                      {profileImageData ? (
                        <img
                          src={profileImageData?.url || profileImageData}
                          alt="Client Profile"
                          onClick={() => setIsProfilePreviewVisible(true)}
                          style={{
                            maxWidth: "100%",
                            maxHeight: 110,
                            objectFit: "contain",
                            borderRadius: 6,
                            border: "1px solid #e5e7eb",
                            cursor: "zoom-in",
                          }}
                        />
                      ) : (
                        <Text
                          style={{
                            fontSize: 12,
                            color: "#9ca3af",
                            fontStyle: "italic",
                          }}
                        >
                          No signature on file
                        </Text>
                      )}
                      <Text
                        style={{
                          marginTop: 10,
                          color: "#374151",
                          fontSize: 13,
                          fontWeight: 600,
                          textAlign: "center",
                        }}
                      >
                        {savingsAccountDetails?.clientName || "—"}
                      </Text>
                      {savingsAccountDetails?.accountNo && (
                        <Text
                          style={{
                            fontSize: 11,
                            color: "#9ca3af",
                            fontFamily: "monospace",
                          }}
                        >
                          {savingsAccountDetails.accountNo}
                        </Text>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            )}

            {/* Withdrawal Details */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 14,
              }}
            >
              {labelConfig.withdrawalSetup}
            </div>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name="transactionDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionDate),
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%", height: 44 }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={labelConfig.transactionAmount}
                  name="amount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionAmount),
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%", height: 44 }}
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(v) => v?.replace(/,/g, "")}
                    placeholder="50,000"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="currencyCode"
                  label={labelConfig.accountCurrency}
                >
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    style={{ height: 44 }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.accountCurrency,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item
                  name="txnNote"
                  label={labelConfig.note}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.note),
                    },
                  ]}
                >
                  <TextArea
                    rows={2}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.note)}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Denomination */}
            <Divider style={{ marginTop: 8, marginBottom: 16 }} />
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 10,
              }}
            >
              Denomination
            </div>

            <Row gutter={16} align="bottom" style={{ marginBottom: 12 }}>
              <Col span={6}>
                <Form.Item
                  label={
                    <Text
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#374151",
                      }}
                    >
                      Denom Code
                    </Text>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Denom code is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: 44 }}
                    placeholder="Select denomination"
                    value={denomInput.denomCode}
                    options={denomOptions}
                    onChange={(v) => handleDenomInputChange("denomCode", v)}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label={
                    <Text
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#374151",
                      }}
                    >
                      Denom Count
                    </Text>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Denom code is required",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%", height: 44 }}
                    placeholder="0"
                    value={denomInput.denomCount}
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(v) => v?.replace(/,/g, "")}
                    onChange={(v) => handleDenomInputChange("denomCount", v)}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label={
                    <Text
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#374151",
                      }}
                    >
                      Denom Value
                    </Text>
                  }
                >
                  <InputNumber
                    style={{ width: "100%", height: 44 }}
                    className="of-bold-disable-input"
                    placeholder="0"
                    value={denomInput.denomValue}
                    formatter={(v) =>
                      `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(v) => v?.replace(/,/g, "")}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label=" ">
                  <Button
                    type="primary"
                    className="of-primaryBtnColor"
                    style={{ height: 44 }}
                    onClick={handleAddDenom}
                  >
                    Add
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            {denomEntries.length > 0 && (
              <Table
                style={{ marginTop: 8 }}
                dataSource={denomEntries}
                rowKey="id"
                pagination={false}
                size="small"
                columns={[
                  {
                    title: "Denom Code",
                    dataIndex: "denomLabel",
                    key: "denomLabel",
                  },
                  {
                    title: "Denom Count",
                    dataIndex: "denomCount",
                    key: "denomCount",
                  },
                  {
                    title: "Denom Value",
                    dataIndex: "denomValue",
                    key: "denomValue",
                    render: (v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                  },
                  {
                    title: "Action",
                    key: "action",
                    render: (_, record) => (
                      <Button
                        type="text"
                        icon={<DeleteOutlined />}
                        className="of-primaryBtnColor"
                        onClick={() => removeDenomEntry(record.id)}
                      />
                    ),
                  },
                ]}
              />
            )}

            {/* ── Actions ──────────────────────────────────────────────────── */}
            <Row style={{ marginTop: 24 }}>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(NewCashWithdrawal);
